export const list = [1, 2, 3, 4]


/**
 *  校验手机号是否正确
 * @param {*} phoneNumber 手机号
 * @returns
 */
export const isValidPhoneNumber = (phoneNumber) => {
  var pattern = /^1\d{10}$/
  if (pattern.test(phoneNumber)) {
    return true
  } else {
    return false
  }
}

/**
 *  防抖
 * @param {*} func
 * @param {*} delay
 * @returns
 */
export const debounce = (func, delay = 800) => {
  let timer = 0
  return function (...args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}